import { Colors } from '../consts/Colors.js';
import AbstractScene from './AbstractScene.js';

export default class Close extends AbstractScene {
    constructor() {
        super({
            key: 'Close',
        });
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
    }

    update() {
        super.update();
    }

    create() {
        this.cameras.main.setBackgroundColor(Colors.Elmt.PaleWhite);

        this.add
            .text(this.width / 2, 30, 'The content has ended. You may close this window..', {
                fontFamily: 'Lato, sans-serif',
                fontSize: '18px',
                color: '#000000',
            })
            .setOrigin(0.5);
    }
}
